import { FormattedMessage } from 'react-intl';

export function AgeRangeText({ min, max }: { min: number | null; max: number | null }) {
  if (min && max) {
    if (min === max) {
      return (
        <FormattedMessage
          id="component:age-range.age-n-only"
          defaultMessage="Age {num} only"
          values={{ num: min }}
        />
      );
    }

    return (
      <FormattedMessage
        id="component:age-range.ages-n-to-n"
        defaultMessage="Ages {min}–{max}"
        values={{ min, max }}
      />
    );
  }

  if (min) {
    return (
      <FormattedMessage
        id="component:age-range.ages-n-and-up"
        defaultMessage="Ages {num} and up"
        values={{ num: min }}
      />
    );
  }

  if (max) {
    return (
      <FormattedMessage
        id="component:age-range.up-to-age-n"
        defaultMessage="Up to age {num}"
        values={{ num: max }}
      />
    );
  }
}
